import { render, staticRenderFns } from "./agent_commission.vue?vue&type=template&id=6d5a1f5f&"
import script from "./agent_commission.vue?vue&type=script&lang=js&"
export * from "./agent_commission.vue?vue&type=script&lang=js&"
import style0 from "./agent_commission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports